window.VegasAccountAuth = {
	container: '.auth-container',
	areaLoginPhone: '#auth-login-phone',
	areaLoginSms: '#auth-login-sms',
	areaErrors: '#auth-errors',

	toggleArea: function (type) {
		if (type === 'sms') {
			$(VegasAccountAuth.areaLoginPhone).slideUp();
			$(VegasAccountAuth.areaLoginSms).slideDown();

			this.reset('sms');
			setTimeout(function () {
				$(VegasAccountAuth.areaLoginSms).find('input.number').first().focus();
			}, 100);
		} else if (type === 'login') {
			$(VegasAccountAuth.areaLoginPhone).slideDown();
			$(VegasAccountAuth.areaLoginSms).slideUp();
			$(VegasAccountAuth.areaLoginPhone).find('[name=phone]').focus();
		}
	},

	toggleError: function (toggle, msg) {
		if (toggle === 'hide') {
			$(VegasAccountAuth.areaErrors).slideUp().find('.alert').html('');
		} else if (toggle === 'show') {
			$(VegasAccountAuth.areaErrors).slideDown().find('.alert').html(msg);
		}
	},

	getSetPhone: function (phone) {
		$(VegasAccountAuth.areaLoginSms).find($('.auth-container--sms-heading span')).text(phone);

		return false;
	},

	post: function ($form, callback) {
		let route = $form.attr('action');
		let params = $form.serializeArray();

		$.post(route, params, function (data) {
			return callback(data);
		});
	},

	reset: function (type) {
		if (type === 'sms') {
			$(VegasAccountAuth.areaLoginSms).find('input.number').val('');
		} else if (type === 'login') {
			$(VegasAccountAuth.areaLoginPhone).find('.btn').attr('disabled', false).find('i').remove();
		}
	}
};

$(document).ready(function () {
	$('#form-auth-login').submit(function () {
		let $form = $(this);

		$form.find('[type=submit]').attr('disabled', true).append('<i class="fa fa-spin fa-spinner"></i>');
		VegasAccountAuth.toggleError('hide');

		let phone = $(this).find('[name=phone]').val();
		$(VegasAccountAuth.areaLoginSms).find('[name=phone]').val(phone);

		VegasAccountAuth.post($form, function (data) {
			VegasAccountAuth.reset('login');

			if (data.error) {
				VegasAccountAuth.toggleError('show', data.msg);
			} else {
				VegasAccountAuth.toggleArea('sms');
			}
		});

		return false;
	});

	$('[data-toggle="auth"]').click(function () {
		let $btn = $(this),
			target = $btn.attr('href') || $btn.data('target') || false;

		if (target) {
			if (target === '#auth-phone') {
				VegasAccountAuth.toggleArea('login');
				$(VegasAccountAuth.areaLoginPhone).find('input.form-control').val('');
			} else if (target === '#auth-retry') {
				$('#form-auth-login').trigger('submit');

				let text = $btn.text();
				$btn.html('<i class="fa fa-spin fa-spinner"></i>');

				setTimeout(() => {
					$btn.text(text);
				}, 1500);
			}
		}

		return false;
	});

	$(VegasAccountAuth.areaLoginSms).find('input').on('keyup', function () {
		let $self = $(this),
			value = $(this).val(),
			$container = $self.parent(),
			$inputs = $container.find('input.number'), completed = 0;

		if (value.length > 1) {
			value = value.slice(0, 1);
			$self.val(value)
		}

		if (value && value.length === 1) {
			$self.next().select();
		}

		if (event.keyCode === 8) {
			$self.prev().select();
		}

		if (event.keyCode === 37) {
			$self.prev().select();
		}

		if (event.keyCode === 39) {
			$self.next().select();
		}

		$inputs.each(function () {
			if ($(this).val()) completed++;
		});

		if ($inputs.length === completed) {
			$inputs.each(function () {
				$(this).attr('readonly', true);
			});

			VegasAccountAuth.post($('#form-auth-sms'), function (data) {
				$inputs.each(function () {
					$(this).attr('readonly', false);
				});

				if (data.error) {
					VegasAccountAuth.toggleError('show', data.msg);

					$inputs.each(function () {
						$(this).val('');
					});

					$(VegasAccountAuth.areaLoginSms).find('input.number').first().focus();
				} else {
					location.href = data.redirect_to;
				}
			});
		}
	});
});